module.exports = __webpack_public_path__ + "img/jianianhua_img2.f8f6662e.jpg";